import { ILLUSTRATIONS } from 'mixtiles-web-common/consts/illustrations.const'
import { CDN_URL } from 'config/config'
import {
  homepageDesktopVideos,
  homepageMobileVideos,
} from './Components/SecondaryVideoSection/SecondaryVideoSection.consts'
import { getCommunityVideos } from './Components/CommunitySection/CommunitySection.consts'
import type { TFunction } from 'i18next'

type HomePageConfig = {
  desktopVideos: typeof homepageDesktopVideos
  mobileVideos: typeof homepageMobileVideos
  getCommunityVideos: (
    t: TFunction,
    pricingCountry: string
  ) => ReturnType<typeof getCommunityVideos>
  heroVideo: {
    desktop: string
    mobile: string
  }
  qualityVideo: {
    desktop: string
    mobile: string
  }
  illustrations: {
    names: {
      rating: string
      satisfaction: string
      shipping: string
      support: string
    }
    mobileUrls: {
      shipping: string
      support: string
      rated: string
    }
  }
}

export const HOMEPAGE_CONFIG: HomePageConfig = {
  desktopVideos: homepageDesktopVideos,
  mobileVideos: homepageMobileVideos,
  getCommunityVideos,
  heroVideo: {
    desktop: 'assets/homepage/2023/videos/title-1-desktop',
    mobile: 'assets/homepage/2023/videos/title-mobile-new',
  },
  qualityVideo: {
    desktop: 'assets/homepage/2023/videos/quality-desktop-2024',
    mobile: 'assets/homepage/2023/videos/quality',
  },
  illustrations: {
    names: {
      rating: ILLUSTRATIONS.HOMEPAGE.RATING,
      satisfaction: ILLUSTRATIONS.HOMEPAGE.SATISFACTION,
      shipping: ILLUSTRATIONS.HOMEPAGE.SHIPPING,
      support: ILLUSTRATIONS.HOMEPAGE.SUPPORT,
    },
    mobileUrls: {
      shipping: `${CDN_URL}/illustrations/homepage/Shipping.png`,
      support: `${CDN_URL}/illustrations/homepage/Support.png`,
      rated: `${CDN_URL}/illustrations/homepage/Rated.png`,
    },
  },
}
